import React from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="mt-5 w-[100%] md:w-1/2 mx-auto bg-gray-100 pt-5 pb-0 border-t border-gray-300 text-left z-[1000]">
      <div>
        <strong className="font-semibold">Free online PDF tools</strong>
      </div>
      <div className="grid md:grid-cols-4 grid-cols-2 gap-auto gap-y-2 mt-2">
        <Link to="/pdf-tools/convert-images-to-PDF" className="text-sm inline-flex items-center">images to PDF <FiExternalLink className="ml-1" /></Link>
        <Link to="/pdf-tools/remove-pages-from-pdf" className="text-sm inline-flex items-center">remove pages <FiExternalLink className="ml-1" /></Link>
        <Link to="/pdf-tools/merge-pdfs" className="text-sm inline-flex items-center">merge PDFs <FiExternalLink className="ml-1" /></Link>
        <Link to="/pdf-tools/compress-pdf" className="text-sm inline-flex items-center">compress PDF <FiExternalLink className="ml-1" /></Link>
      </div>
    </footer>
  );
};

export default Footer;
